<div class="topbar">
    <div nxLayout="grid maxwidth">
        <div nxRow>
            <div nxCol="12">
                <cpc-topbar *ngIf="loggedUser.authenticated"
                    (logoClicked)="logoClicked($event)">
                    <cpc-menu desktop class="desktop">
                        <cpc-menu-item *ngFor="let route of getMenuItems()">
                            <li class="cpc-menu-list-item"
                                [ngClass]="{'cpc-menu-list-item_icon-highlighted' : route.data.active}">
                                <span [routerLink]="route.path" translate>
                                    {{route.data.textToTranslate}}
                                </span>
                            </li>
                        </cpc-menu-item>
                    </cpc-menu>

                    <div class="cpc-topbar-user-wrapper" desktop>
                        <div class="mail-icon-topbar"
                            *ngIf="this.hasUserRole(commonService.userRoles.Individual)">
                            <a [routerLink]="['/inbox']">
                                <cpc-icon class="cpc-topbar-icon"
                                    icon="mail-o"></cpc-icon>
                                <span class="mail-icon-topbar-count"
                                    *ngIf="notOpenedMails>0">{{notOpenedMails}}</span>
                            </a>
                        </div>
                        
                        <cpc-user-profile-dropdown [name]="topBarName" #userProfileDropdown>
                            <div
                                *ngIf="this.hasUserRole(commonService.userRoles.Individual)">
                                <nx-link nxStyle='block'>
                                    <a [routerLink]="['/moj-profil']">
                                        <cpc-icon icon='user-o'></cpc-icon>
                                        {{'topbar.menu.my-profile' | translate}}
                                    </a>
                                </nx-link>
                            </div>
                            <div
                                *ngIf="this.hasUserRole(commonService.userRoles.LegalPerson) && loggedUser.isAdmin">
                                <nx-link nxStyle='block'>
                                    <a [href]='getAccessManagementUrl()'>
                                        <cpc-icon icon='users-o'></cpc-icon>
                                        {{'topbar.menu.access-management' |
                                        translate}}
                                    </a>
                                </nx-link>
                            </div>
                            <div>
                                <nx-link nxStyle='block'>
                                    <a [href]="logoutUrl">
                                        <cpc-icon icon='Logout'></cpc-icon>
                                        {{'topbar.menu.logout' | translate}}
                                    </a>
                                </nx-link>
                            </div>
                        </cpc-user-profile-dropdown>


                        <cpc-language-switch [activeLanguage]="activeLanguage"
                            [languages]="languages"
                            [disableOutsideClose]="false" [hideGlobe]="false"
                            (changeLanguage)="changeLanguage($event)">
                        </cpc-language-switch>
                    </div>

                    <div class="cpc-topbar-user-wrapper" mobile>

                        <div class="mail-icon-topbar"
                            *ngIf="this.hasUserRole(commonService.userRoles.Individual)">
                            <a [routerLink]="['/inbox']">
                                <cpc-icon (click)="clickInbox($event)"
                                    class="cpc-topbar-icon"
                                    icon="mail-o"></cpc-icon>
                                <span class="mail-icon-topbar-count"
                                    *ngIf="notOpenedMails>0">{{notOpenedMails}}</span>
                            </a>
                        </div>

                        <cpc-menu *ngIf="isDrawerOpen"
                            [(drawerOpenModel)]="isDrawerOpen">
                            <cpc-menu-item>
                                <cpc-user-profile-dropdown [name]="topBarName"
                                    style="display: inline-flex"
                                    class="cpc-menu-list-item">

                                    <div
                                        *ngIf="this.hasUserRole(commonService.userRoles.Individual)">
                                        <nx-link nxStyle='block'>
                                            <a [routerLink]="['/moj-profil']">
                                                <cpc-icon
                                                    icon='user-o'></cpc-icon>
                                                {{'topbar.menu.my-profile' |
                                                translate}}
                                            </a>
                                        </nx-link>
                                    </div>
                                    <div
                                        *ngIf="this.hasUserRole(commonService.userRoles.LegalPerson) && loggedUser.isAdmin">
                                        <nx-link nxStyle='block'>
                                            <a [href]='getAccessManagementUrl()'>
                                                <cpc-icon
                                                    icon='users-o'></cpc-icon>
                                                {{'topbar.menu.access-management' |
                                                translate}}
                                            </a>
                                        </nx-link>
                                    </div>


                                </cpc-user-profile-dropdown>
                            </cpc-menu-item>
                            <cpc-menu-item *ngFor="let route of getMenuItems()">
                                <li [ngClass]="{'cpc-menu-list-item_icon-highlighted' : route.data.active}"
                                    class="cpc-menu-list-item">
                                    <span class="cpc-menu-list-item_text"
                                        [routerLink]="route.path" translate>
                                        {{route.data.textToTranslate}}
                                    </span>
                                </li>
                            </cpc-menu-item>
                            <cpc-menu-item *ngIf="this.hasUserRole(commonService.userRoles.Individual)">
                                <li class="cpc-menu-list-item">
                                    <a [routerLink]="['/moj-profil']">
                                        <span
                                            class="cpc-menu-list-item_text">{{'topbar.menu.my-profile'
                                            | translate}}</span>
                                    </a>
                                </li>
                            </cpc-menu-item>

                            <cpc-menu-item *ngIf="this.hasUserRole(commonService.userRoles.LegalPerson) && loggedUser.isAdmin">
                                <li class="cpc-menu-list-item">
                                    <a [href]='getAccessManagementUrl()'>
                                        <span
                                            class="cpc-menu-list-item_text">{{'topbar.menu.access-management'
                                            | translate}}</span>
                                    </a>
                                </li>
                            </cpc-menu-item>

                            <cpc-menu-item>
                                <cpc-language-switch
                                    [activeLanguage]="activeLanguage"
                                    [languages]="languages"
                                    (changeLanguage)="changeLanguage($event)"
                                    [disableOutsideClose]="true"
                                    class="cpc-menu-list-item">
                                </cpc-language-switch>
                            </cpc-menu-item>
                            <cpc-menu-item>
                                <li [title]="Logout"
                                    class="cpc-menu-list-item cpc-menu-list-item_icon-highlighted logout">
                                    <a [href]="logoutUrl">
                                        <span
                                            class="cpc-menu-list-item_text">{{'topbar.menu.logout'
                                            | translate}} <cpc-icon
                                                icon="Logout"
                                                class="cpc-menu-list-item_icon"></cpc-icon></span>
                                    </a>
                                </li>
                            </cpc-menu-item>
                        </cpc-menu>
                        <cpc-icon (click)="handleOpen()"
                            [ngClass]="{ 'cpc-topbar-icon--active' : isDrawerOpen }"
                            class="cpc-topbar-icon"
                            [icon]="isDrawerOpen ? 'close' : 'bars'">
                        </cpc-icon>
                    </div>
                </cpc-topbar>

            </div>
        </div>
    </div>
</div>
<div nxLayout="grid maxwidth" class="top-divider"></div>
